import {
  REQUEST_SOCIAL_PLATFORM_LIST_SUCCESS,
  REQUEST_SOCIAL_PLATFORM_LIST_FAILURE
} from '../constants/actionTypes';

const INITIAL_STATE = { ids: [], error: null };

export default function socialPlatform(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_SOCIAL_PLATFORM_LIST_SUCCESS:
      return {
        ids: action.payload.data.map(data => parseInt(data.id, 10)),
        error: null
      };
    case REQUEST_SOCIAL_PLATFORM_LIST_FAILURE:
      return {
        ...state,
        ids: [],
        error: action.payload.message
      };
    default:
      return state;
  }
}
